<template>
<transition name="slide-fade" mode="out-in"> 
  <div id="index" v-wechat-title="$route.meta.title">
    <img src="@/assets/index.png" />
    <div class="btns">
      <div class="btn2 animate__animated animate__fadeInUp" @click="toUrl('/service')">“三务”公开</div>
      <div class="btn1 animate__animated animate__fadeInUp" @click="toUrl('/notice')">一键举报</div>
    </div>
  </div>
</transition>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toUrl(r) {
      this.$router.push(r);
    }
  }
};
</script>
<style scoped>
#index {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#index img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
}
.btns {
      position: absolute;
    width: 100%;
    top: 35%;
}
.btns div {
  width: 50%;
  margin: 0 auto;
  background: #226ea7;
  color: white;
  line-height: 3rem;
  height: 3rem;
  border-radius: 5px;
  margin-bottom: 3rem;
  font-weight: bold;
}
.btn1 {
  animation-delay: 0.7s;
  -webkit-animation-delay: 0.7s; /* Safari 和 Chrome */
}
</style>


// WEBPACK FOOTER //
// src/page/index.vue